import { PureComponent, Fragment } from 'react';
import { debounce } from 'lodash';
import styled from 'styled-components';

// COMPONENTS
import { IconButton } from 'components/Buttons';
import { Select } from 'componentsV2/Select';

// HOCS
import withTooltip from 'hocs/Tooltip';
import withFormField from './withFormField';

// STYLES
import { RefreshButtonWrapper } from 'components/Inputs/Inputs.styles';
import { LOADING, DISABLED } from 'styles/commonClasses';
import { animationLength } from 'styles/animation';

import ConnectedMetadata from './connectedMetadata';

const RefreshIcon = withTooltip(IconButton);

const FieldContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;

  & > [data-component='_Select'] {
    width: 100%;
  }
`;

class _ConnectedFieldInner extends PureComponent {
  render() {
    // @ts-expect-error TS(2339): Property 'hasValue' does not exist on type 'Readon... Remove this comment to see the full error message
    const { children, hasValue, isConnected, isManuallyEdited, lastConnectedDate, readOnly, statusText, isValid } =
      this.props;

    return (
      <Fragment>
        <FieldContainer>{children}</FieldContainer>
        <ConnectedMetadata
          connectivityStatusText={statusText}
          hasValue={hasValue}
          isConnected={isConnected}
          isManuallyEdited={isManuallyEdited}
          isValid={isValid}
          lastConnectedDate={lastConnectedDate}
          readOnly={readOnly}
        />
      </Fragment>
    );
  }
}

const ConnectedFieldInner = withFormField(_ConnectedFieldInner);

class ConnectedField extends PureComponent {
  state = {
    animated: false,
  };

  handleClick = () => {
    // @ts-expect-error TS(2339): Property 'isConnected' does not exist on type 'Rea... Remove this comment to see the full error message
    if (this.props.isConnected) {
      this.setState(
        {
          animated: true,
          animationStart: new Date(),
        },
        () => {
          // Ensure state has been updated before proceeding
          // @ts-expect-error TS(2339): Property 'onClickRefresh' does not exist on type '... Remove this comment to see the full error message
          this.props.onClickRefresh(); // Synchronous in this case

          // Before stopping the animation, ensure it can run a little
          // @ts-expect-error TS(2362): The left-hand side of an arithmetic operation must... Remove this comment to see the full error message
          const resetDelay = new Date() - this.state.animationStart;
          if (resetDelay < animationLength) {
            // cycle length from styles/animation.js
            // Let animation run for at least one cycle
            setTimeout(() => this.setState({ animated: false }), animationLength - resetDelay);
          } else {
            this.setState({ animated: false });
          }
        }
      );
    }
  };

  debouncedHandleClick = debounce(this.handleClick, 1000, {
    leading: true,
    trailing: false,
  });

  handleAnimationIteration = () => {
    this.setState({
      animated: false,
    });
  };

  getLabelChildren = () => {
    // @ts-expect-error TS(2339): Property 'disabled' does not exist on type 'Readon... Remove this comment to see the full error message
    if (this.props.disabled) {
      return null;
    }

    let iconClassName = 'icon-refresh';

    if (this.state.animated) {
      iconClassName += ` ${LOADING}`;
    }

    // @ts-expect-error TS(2339): Property 'isConnected' does not exist on type 'Rea... Remove this comment to see the full error message
    if (!this.props.isConnected) {
      iconClassName += ` ${DISABLED}`;
    }

    return () => (
      <RefreshButtonWrapper>
        <RefreshIcon
          // @ts-expect-error TS(2769): No overload matches this call.
          className={iconClassName}
          suppressTooltip={this.state.animated}
          onAnimationIteration={this.handleAnimationIteration}
          onClick={this.debouncedHandleClick}
          tooltip={{
            // @ts-expect-error TS(2339): Property 'isConnected' does not exist on type 'Rea... Remove this comment to see the full error message
            translationId: this.props.isConnected
              ? 'tooltips.connectedFieldRefresh'
              : 'tooltips.vehicleMustBeConnected',
          }}
        />
      </RefreshButtonWrapper>
    );
  };

  render() {
    // @ts-expect-error TS(2322): Type '{ children?: ReactNode; labelChildren: () =>... Remove this comment to see the full error message
    return <ConnectedFieldInner labelChildren={this.getLabelChildren()} {...this.props} />;
  }
}

export default ConnectedField;
